import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener
} from '@angular/core';
import { StepsService } from '@shared/services/steps/steps.service';
import { SIGNUP_HEADERS } from '@shared/constants/signup-headers';
import { ViewportService } from '@shared/services/viewport/viewport.service';

@Component({
  selector: 'form-progress-bar',
  templateUrl: './form-progress-bar.component.html',
  styleUrls: ['./form-progress-bar.component.scss']
})
export class FormProgressBarComponent implements OnInit, AfterViewInit {
  steps;
  stepWidth = '25%';
  isMobile;
  @Input()
  set ProgressSteps(steps) {
    this.steps = steps;
    const currentStep = this.checkCurrentStep(this.steps)[0];
    this.stepWidth = `${(100 / this.steps.length).toFixed(2)}%`;
    this.initStepService(currentStep);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._viewportService.checkViewSizes();
    }, 250);
  }

  constructor(
    private _stepsService: StepsService,
    private changeDetectorRef: ChangeDetectorRef,
    private _viewportService: ViewportService
  ) {
    this._viewportService.updatingView.subscribe(() => {
      this.isMobile = this._viewportService.isMobile();
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this._viewportService.checkViewSizes();
  }

  initStepService(currentStep) {
    this._stepsService.setHeaderTexts(this.getHeader(currentStep.id));
    this._stepsService.setDoneSteps(this.initDoneSteps());
  }

  checkCurrentStep(steps) {
    return steps.filter(step => step.currentStep);
  }

  getHeader(id) {
    switch (id) {
      case 0:
        return SIGNUP_HEADERS.PERSONAL_DETAILS;
      case 1:
        return SIGNUP_HEADERS.CONTACT_INFORMATION;
      case 2:
        return SIGNUP_HEADERS.CONFIRM_PRE_ORDER_DETAILS;
      default:
        return SIGNUP_HEADERS.PERSONAL_DETAILS;
    }
  }

  initDoneSteps() {
    const doneSteps = [];

    for (const step of this.steps) {
      if (!step.currentStep) {
        doneSteps.push(step.id);
      } else {
        break;
      }
    }
    return doneSteps;
  }
}
